<template>
  <div>
    <el-rate ref="rate" v-model="initValue" v-bind="{ ...item }" @change="handleChange" />
    <div v-if="item['show-auxiliary-text']" class="flex-row el-rate-text-wrap">
      <p class="el-rate-text">{{ item.textLeft }}</p>
      <p class="el-rate-text" style="text-align: center">{{ item.textCenter }}</p>
      <p class="el-rate-text" style="text-align: right">{{ item.textRight }}</p>
    </div>
  </div>
</template>

<script>
import mixin from '../mixin'

export default {
  name: 'TRate',
  mixins: [mixin],
  data() {
    console.log('TRate')
    return {
      oldValue: null
    }
  },
  methods: {
    handleChange(val) {
      this.changeValue = val
      // 重复点击说明是想取消
      if (this.changeValue === this.oldValue) {
        this.changeValue = ''
        this.oldValue = null
        this.initValue = 0
      } else {
        this.oldValue = val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/mixin.scss';
.el-rate-text-wrap {
  justify-content: space-between;
  margin-top: 5px;
}
.el-rate-text {
  width: 82px;
  @include text-overflow;
}
</style>
